// Constants
export const BLANK_CODE_ROW = {
	code: '',
	description: '',
	employerRate: '',
	employeeRate: '',
	isActive: true,
	historyData: null,
};
